import layout from './NavigationView.html?raw';
import View from '@/Views/View';
import ComponentManager from '@/Management/ComponentManager';
import StorageHelper from '@/Utility/StorageHelper';
import NavigationViewModel from '@/ViewModels/Views/NavigationViewModel';
import Utilities from '@/Utility/Utilities';

export default class NavigationView extends View {
    private view: JQuery<HTMLElement>;

    private navigationResizeWidth: KnockoutObservable<number>

    public constructor(private viewModel: NavigationViewModel, private element?: JQuery<HTMLElement>) {
        super();

        this.navigationResizeWidth = this.observableOrDefault(300);
    }

    public getView(): JQuery<HTMLElement> {
        if (this.view != null) {
            return this.view;
        }

        this.view = this.applyBindings(this.element, this.viewModel, layout);
        
        this.applyResizeBindings();
        return this.view;
    }

    private applyResizeBindings(): void {
        const resizeHandle = this.view.find(".navigation-resize-handle")
        const navigation = $('[data-region="Navigation"]')
        const content = $('[data-region="Content"]')
        
        this.navigationResizeWidth.subscribe((width) => {
            navigation.css({ width: `${width}px` });
            content.css({ marginLeft: `${width}px` });
        });

        const navigationExpandedBinding = StorageHelper.bind("WireframeExpanded", true);
        navigationExpandedBinding.subscribe((isExpanded) => {
            const width = isExpanded ? 300 : 0;

            navigation.animate({ width: `${width}px` }, 100);
            content.animate({ marginLeft: `${width}px` }, 100);
            $(window).trigger('resize');
        })

        //Set initial Value
        navigationExpandedBinding.notifySubscribers(navigationExpandedBinding());
        
        this.addEventHandler('mousedown', resizeHandle,(event: MouseEvent) => {
            if (event.button !== 0) return;
            event.preventDefault();

            resizeHandle.addClass("handle-dragging")

            const initialSize = navigation.width();
            const startDrag = event.clientX;
            const doc = $(document);

            this.removeEventHandler('mouseup', doc);
            this.removeEventHandler('mousemove', doc);
            
            this.addEventHandler('mousemove', doc, (event : MouseEvent) => {
                let size = initialSize - startDrag + event.clientX;
                size = Math.max(Math.min(size, 500), 250);
                if (navigation.width() != size) {
                    this.navigationResizeWidth(size);
                }
            });

            this.addEventHandler('mouseup', doc, (event: MouseEvent) => {
                if (event.button !== 0) return;
                resizeHandle.removeClass("handle-dragging");

                this.removeEventHandler('mouseup', doc);
                this.removeEventHandler('mousemove', doc);
            })
        })
    }
}

ComponentManager.setView('LegacyNavigationView', NavigationView, 'RADPresentation.HTMLClient.DefaultViewExtensions');